import { useCallback, useEffect } from 'react';
import { ENDED_VOICE_STATE } from './useVoiceState';

export function useVoiceLifecycle(call, end, update) {
  // This ref owns a changing call, not a DOM node: cleanup must close the latest owner.
  const closeCurrentCall = useCallback(() => call.current?.close(), [call]);
  useEffect(() => {
    const coordinate = event => {
      const active = call.current;
      if (active && !active.closed && active.id !== event.detail) end();
    };
    window.addEventListener('lawyah-call-starting', coordinate);
    return () => window.removeEventListener('lawyah-call-starting', coordinate);
  }, [call, end]);
  useEffect(() => {
    const unload = () => { closeCurrentCall(); update(ENDED_VOICE_STATE); };
    window.addEventListener('pagehide', unload);
    return () => { window.removeEventListener('pagehide', unload); closeCurrentCall(); };
  }, [closeCurrentCall, update]);
}